import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ProcessMocnWork request (FormData for file upload)
export const ProcessMocnWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessMocnWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Generate Regeneration-Based Audit (new approach comparing with regenerated scripts)
export const GenerateRegenerationAuditRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/GenerateAuditSummary`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Generate enodebPairing request
export const ProcessEnodebPairingWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessEnodebPairingWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};